import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { Skeleton } from '../../../components/common/Skeleton';
import { BusinessHoursSection } from '../../../components/settings/BusinessHoursSection';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { palette, admin } from '../../../styles/tokens';

export function BusinessHoursPage() {
  const authBusiness = useAuthStore(s => s.business);
  const { businessHours, loading, error, saved, updateBusinessHours } = useSettings(authBusiness?.id);

  if (loading) {
    return (
      <SettingsSubPage title="Business hours" description="Weekly schedule, holidays, closed dates">
        <div style={{ padding: 20, background: palette.white, borderRadius: admin.cardRadius, border: `1px solid ${admin.border}` }}>
          <Skeleton width={200} height={16} style={{ marginBottom: 12 }} />
          <Skeleton height={14} style={{ marginBottom: 8 }} />
          <Skeleton height={14} />
        </div>
      </SettingsSubPage>
    );
  }

  if (error) {
    return (
      <SettingsSubPage title="Business hours" description="Weekly schedule, holidays, closed dates">
        <div style={{ padding: 40, textAlign: 'center', color: palette.red, fontSize: 13.5 }}>{error}</div>
      </SettingsSubPage>
    );
  }

  return (
    <SettingsSubPage title="Business hours" description="Weekly schedule, holidays, closed dates">
      {saved && (
        <div style={{
          position: 'fixed', top: 68, right: 36, zIndex: 100,
          padding: '10px 20px', borderRadius: 8,
          background: palette.greenWash, border: `1px solid ${palette.green}`,
          color: palette.green, fontSize: 13, fontWeight: 500,
        }}>
          Saved
        </div>
      )}
      <BusinessHoursSection hours={businessHours} onSave={updateBusinessHours} />
    </SettingsSubPage>
  );
}
